import React, { useState } from "react";
import { client } from "../../../../service/ApolloClient/ApolloClient";
import { QUERY_USERS } from "../../../../service/ApolloClient/ApolloQueries";
import Wrapper from "../../../../hoc/Wrapper/Wrapper";
import { Box, Dialog, DialogTitle, IconButton } from "@material-ui/core";
import AutoCompleteMU from "../../../UI/AutoCompleteMU/AutoCompleteMU";
import AddIcon from "@material-ui/icons/Add";
import UserAddModal from "../../../Form/UserAddModal";

const UserSelect = (props) => {
  const { title, setFieldValue, value, fieldName, fieldNameShow } = props;
  const [keyword, setKeyword] = useState(props.value);
  const [modalOpen, setModalOpen] = useState(false);
  const query = client
    .query({
      query: QUERY_USERS,
      variables: {
        search: keyword,
        limit: 20,
        page: 1,
      },
      fetchPolicy: "network-only",
    })
    .catch((err) => console.log(err));

  const handleClose = () => {
    setModalOpen(false);
  };

  return (
    <Wrapper>
      <Box display={"flex"} p={1}>
        <Box flexGrow={1}>
          <AutoCompleteMU
            fieldNameShow={"recieverable_name"}
            value={value ? value : ""}
            title={"انتخاب حقیقی"}
            setFieldValue={setFieldValue}
            keyword={keyword}
            setKeyword={setKeyword}
            query={query}
            queryName={"users"}
            field={["fullname"]}
            fieldSelect={"id"}
            fieldName={"recieverable_id"}
          />
        </Box>
        {props.disabledAdd ? null : (
          <Box>
            <IconButton
              onClick={(e) => {
                setModalOpen(!modalOpen);
              }}
            >
              <AddIcon />
            </IconButton>

            <Dialog
              open={modalOpen}
              onClose={handleClose}
              aria-labelledby="form-dialog-title"
            >
              <DialogTitle id="form-dialog-title">افزودن کاربر</DialogTitle>
              <UserAddModal handleClose={handleClose} />
            </Dialog>
          </Box>
        )}
      </Box>
    </Wrapper>
  );
};

export default React.memo(UserSelect);
